<template>
  <div>
    <b-form @submit.prevent="searchByAddress">
      <label for="searchBox">
        {{ $t("tripPlan.searchClausule") }}
      </label>
      <b-input-group>
        <b-form-input
          id="searchBox"
          type="text"
          v-model="searchQuery"
          :placeholder="$t('tripPlan.searchClausule')"
        >
        </b-form-input>
        <b-input-group-append lg="6" md="6" sm="12">
          <b-button size="sm" type="submit">
            <i class="tim-icons icon-zoom-split" style="padding-top: 25%"> </i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "GoogleMapSearchbar",
  props: {
    searchQuery: String
  },
  data() {
    return {
      map: null,
      apiKey: "AIzaSyD8EoBpPYU3QMSy26N92UOdYpmfOfiyb8Y"
    };
  },
  methods: {
    searchByAddress() {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: this.searchQuery }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          const { lat, lng } = results[0].geometry.location;
          const fullAddress = results[0].formatted_address;
          const searchResult = {
            latitude: lat(),
            longitude: lng(),
            fullAddress
          };
          this.$emit("onSearch", searchResult);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    }
  }
};
</script>
